$(() => {
	// Dichiaro le variabili
    const body = document.querySelector("body");
    const header = document.querySelector("#header");
	const toggle = document.querySelector(".hamburger");
	const menuPanel = document.querySelector(".menu-panel");

	//let panelLeft = document.querySelector(".panel-left");
	//let panelRight = document.querySelector(".panel-right");
	const menuHasChildren = document.querySelectorAll(
		".menu-panel .menu-item-has-children"
	);

    menuPanel.style.paddingTop = header.clientHeight + "px";

	const mediaQuery = [window.matchMedia("(min-width: 768px)")];
	subMenu(mediaQuery[0]);

	// Evento di click per apertura
	toggle.addEventListener("click", function (e) {
		toggleMenu();
	});

	function subMenu(event) {
		if (event.matches) {
			menuHasChildren.forEach(function (el, i) {
				el.querySelector("a").addEventListener("click", function (e) {
					e.preventDefault();
					let subMenu = el.querySelector(".sub-menu").cloneNode(true);
					/*$(panelRight).fadeOut(500, "swing", function () {
						panelRight.innerHTML = "";
						panelRight.append(subMenu);
						$(panelRight).fadeIn(500);
					});*/
				});
			});
		} else {
			menuHasChildren.forEach(function (el, i) {
				el.querySelector("a").addEventListener("click", function (e) {
					e.preventDefault();
					el.querySelector(".sub-menu").classList.toggle("show");
				});
			});
		}
	}

	function toggleMenu() {
		toggle.classList.toggle("is-active");
		body.classList.toggle("no-scroll");
		menuPanel.classList.toggle("in");
	}
});
